import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import gachibowli from "./assets/gachibowli_outlet.png";
import jubilee from "./assets/jubliee_outlet.png";
import newOutlet from "./assets/new_outlet.png";
import logo from "./assets/logo.png";
import foodImage from "./assets/food_image.png";
import drinkImage from "./assets/drinks_image.png";
import musicImage from "./assets/music_image.png";
import offerImage from "./assets/food_image.png";
import PrivacyPolicy from "./PrivacyPolicy";
import CancellationAndRefund from "./CancellationAndRefund";
import TermsAndConditions from "./TermsAndConditions";
import ShippingPolicy from "./ShippingPolicy";

function HomePage() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="App">
      {/* Navbar */}
      <header className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Airlive Logo" />
          </Link>
        </div>
        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          ☰
        </button>
        <nav className={menuOpen ? "open" : ""}>
          <Link to="/">Home</Link>
          <a href="#about">About</a>
          <a href="#branches">Branches</a>
          <a href="#services">Services</a>
          <a href="#gallery">Gallery</a>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-text">
          <img src={logo} alt="Airlive Logo" className="hero-logo" />
          <h1>Welcome to Airlive</h1>
          <p>Hyderabad’s ultimate destination for music, food, and nightlife.</p>
          <img src={offerImage} alt="offer" className="offer-simple" />
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section about">
        <h2>About Us</h2>
        <div className="about-content">
        <p>
          At Airlive, we bring together the best of music, food, and nightlife
          under one roof. Located in the heart of Hyderabad, Airlive is known
          for its high-energy live performances, premium food and drinks, and
          a stunning rooftop seating experience.
        </p>
        <p>
          Whether you’re here for a casual evening, a night of dancing, or to
          enjoy live bands with friends, Airlive is where unforgettable moments
          are made. With multiple branches across the city, we continue to set
          the benchmark for nightlife experiences.
        </p>

        </div>
      </section>

      {/* Branches Section */}
      <section id="branches" className="section branches">
        <h2>Our Branches</h2>
        <div className="branch-cards">
          <div className="branch-card">
            <img src={gachibowli} alt="Gachibowli Outlet" />
            <h3>Gachibowli</h3>
          </div>
          <div className="branch-card">
            <img src={jubilee} alt="Jubilee Hills Outlet" />
            <h3>Jubilee Hills</h3>
          </div>
          <div className="branch-card">
            <img src={newOutlet} alt="Kondapur" />
            <h3>Kondapur</h3>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="section services">
        <h2>What We Offer</h2>
        <div className="service-cards">
          <div className="service-card">
            <h3>🎶 Live Music</h3>
            <p>
              Enjoy soulful performances and electrifying live bands that make
              every night unforgettable.
            </p>
          </div>
          <div className="service-card">
            <h3>🌌 Rooftop Seating</h3>
            <p>
              Dine and unwind under the stars with a serene and stylish rooftop
              ambiance.
            </p>
          </div>
          <div className="service-card">
            <h3>🍴 Food & Drinks</h3>
            <p>
              Relish world-class cuisines and sip on signature cocktails crafted
              by our expert mixologists.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="gallery">
        <div className="gallery-simple">
          <div className="top-row">
            <div>
              <img src={foodImage} alt="Food" />
              <h3>Delicious Food</h3>
            </div>
            <div>
              <img src={drinkImage} alt="Drinks" />
              <h3>Refreshing Drinks</h3>
            </div>
          </div>
          <div className="bottom-row">
            <div>
              <img src={musicImage} alt="Live Music" />
              <h3>Live Music</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Line + Contact + Privacy */}
      <div className="footer-line"></div>
      <div className="footer-main">
        <div className="contact-info">
          <h3>Contact Us</h3>
          <p>📍 Address: 5F - 031, 040, Gachibowli - Miyapur Rd, Kondapur, Whitefields, Kondapur, Hyderabad, Telangana 500084</p>
          <p>📞 Phone: +91 91606 10002</p>
          <p>📧 Email: airlive.app@gmail.com</p>
        </div>
        <div className="privacy-link">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/cancellation-refund">Cancellation and Refund</Link>
          <Link to="/terms-conditions">Terms and Conditions</Link>
          <Link to="/shipping-policy">Shipping Policy</Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Alive Hospitality. All Rights Reserved to alive hospitality.</p>
      </footer>

      {/* Privacy Modal */}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-refund" element={<CancellationAndRefund />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
